import React from 'react';
import { Link } from 'react-router-dom';
import './Cart.css';
import { useShop } from '../context/ShopContext';
import { formatPrice } from '../data/products';

function Cart() {
  const { cartItems, cartTotal, updateQuantity, removeFromCart, clearCart } =
    useShop();

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-header">
          <h1>Your Cart</h1>
          <p>Your cart is empty. Start shopping to add items.</p>
          <div className="cart-actions">
            <Link className="primary-btn" to="/mens">
              Shop Men's
            </Link>
            <Link className="ghost-btn" to="/womens">
              Shop Women's
            </Link>
            <Link className="ghost-btn" to="/kids">
              Shop Kids
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-header">
        <h1>Your Cart</h1>
        <p>Review your items and adjust quantities before checkout.</p>
      </div>

      <div className="cart-layout">
        <div className="cart-list">
          {cartItems.map((item) => (
            <div className="cart-item" key={item.variantKey || item.id}>
              <div className="cart-thumb">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="cart-details">
                <h3>{item.title}</h3>
                <p className="cart-meta">
                  {item.brand && `${item.brand} · `}{' '}
                  {item.categoryLabel || item.category}
                </p>
                {(item.size || item.color) && (
                  <p className="cart-meta">
                    {item.size && `Size: ${item.size}`}{" "}
                    {item.color && `Color: ${item.color}`}
                  </p>
                )}
                <p className="cart-price">
                  {formatPrice(item.price, item.currency)}
                </p>
                <div className="cart-controls">
                  <div className="quantity">
                    <button
                      onClick={() =>
                        updateQuantity(
                          item.variantKey || item.id,
                          Math.max(1, item.quantity - 1)
                        )
                      }
                    >
                      −
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      onClick={() =>
                        updateQuantity(item.variantKey || item.id, item.quantity + 1)
                      }
                    >
                      +
                    </button>
                  </div>
                  <button
                    className="link-btn"
                    onClick={() =>
                      removeFromCart(item.variantKey || item.id)
                    }
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="cart-summary">
          <h4>Order Summary</h4>
          <div className="summary-row">
            <span>Subtotal</span>
            <span>{formatPrice(cartTotal, 'AUD')}</span>
          </div>
          <div className="summary-row muted">
            <span>Shipping</span>
            <span>Calculated at checkout</span>
          </div>
          <div className="summary-row total">
            <span>Total</span>
            <span>{formatPrice(cartTotal, 'AUD')}</span>
          </div>
          <button className="primary-btn checkout-btn">Checkout</button>
          <button className="ghost-btn full" onClick={clearCart}>
            Clear Cart
          </button>
        </div>
      </div>
    </div>
  );
}

export default Cart;
